import CommonDelete from "@/components/common/Delete"
import CommonList from "@/components/common/List"
import CommonTableList from "@/components/common/TableList"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { VendorData } from "@/interface/entityInterface"
import { ColumnDef } from "@tanstack/react-table"
import { MoreVerticalIcon } from "lucide-react"
import VendorsCreate from "./VendorsCreate"
import VendorsEdit from "./VendorsEdit"

const VendorsList = () => {
    const columns: ColumnDef<VendorData>[] = [
        {
            id: "select",
            header: ({ table }) => (
                <Checkbox
                    checked={
                        table.getIsAllPageRowsSelected() ||
                        (table.getIsSomePageRowsSelected() && "indeterminate")
                    }
                    onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
                    aria-label="Select all"
                />
            ),
            cell: ({ row }) => (
                <Checkbox
                    checked={row.getIsSelected()}
                    onCheckedChange={(value) => row.toggleSelected(!!value)}
                    aria-label="Select row"
                />
            ),
            enableSorting: false,
            enableHiding: false,
        },
        {
            accessorKey: "id",
            header: "ID",
            cell: ({ row }) => (
                <div className="capitalize">{row.getValue("id")}</div>
            ),
        },
        {
            accessorKey: "vendor_name",
            header: "Vendor Name",
            cell: ({ row }: any) => (
                <div className="capitalize">{row.getValue("vendor_name")}</div>
            ),
        },
        {
            accessorKey: "notes",
            header: "Notes",
            cell: ({ row }: any) => (
                <div>{row.getValue("notes")}</div>
            ),
        },
        {
            id: "actions",
            cell: ({ row }) => (
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button
                            variant="ghost"
                            className="flex size-8 text-muted-foreground data-[state=open]:bg-muted"
                            size="icon"
                        >
                            <MoreVerticalIcon />
                            <span className="sr-only">Open menu</span>
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="w-32">
                        <VendorsEdit prop={row.original.id} />
                        <DropdownMenuSeparator />
                        <CommonDelete id={row.original.id} responseMessage={`${row.original.vendor_name} is no longer a vendor`} resource="vendors" description="This action can not be undone" />
                    </DropdownMenuContent>
                </DropdownMenu>
            ),
        }
    ]
    return (
        <CommonList>
            <CommonTableList filterSearch="notes" columns={columns} create={<VendorsCreate />} />
        </CommonList>
    )
}

export default VendorsList